import { useCallback, useEffect, useState } from "react";
import { TAB_COUNT_REFRESH_MS } from "../constants";
import worklistApi from "../services/worklistApi";

// Tab badges: cached server-side; refreshed every minute while the page is visible.
export function useTabCounts() {
  const [counts, setCounts] = useState<Record<number, number>>({});
  const [updatedAt, setUpdatedAt] = useState<number | null>(null);
  const [, setTick] = useState(0);

  const refresh = useCallback(async (force = false) => {
    try {
      setCounts(await worklistApi.tabCounts(force));
      setUpdatedAt(Date.now());
    } catch {
      // badges are non-critical
    }
  }, []);

  useEffect(() => {
    refresh(false);
    const poll = setInterval(
      () => document.visibilityState === "visible" && refresh(false),
      TAB_COUNT_REFRESH_MS
    );
    // re-render so "updated Ns ago" stays current
    const tick = setInterval(() => setTick((n) => n + 1), 15000);
    return () => {
      clearInterval(poll);
      clearInterval(tick);
    };
  }, [refresh]);

  return { counts, updatedAt, refresh };
}
